import React, { useEffect, useState } from "react";
import Modal from "../common/Modal/Modal";
import MHeader from "./common/MHeader";
import MFooter from "./common/MFooter";
import { ReactComponent as CloseIcon } from "./../../resources/images/icons/modalCloseIcon.svg";
import { JobsDataType } from "../../types/api-response";
import {
  useExpireJobMutation,
  useRenewJobMutation,
} from "../../redux/apis/manageJobPostingHooks";
// import CustomSnackbar from "../common/Snackbar/CustomSnackbar";
import EditIcon from "../../resources/images/icons/EditIcon";
import { toast } from "react-toastify";
import getMappedJobType from "../common/utils/getMappedJobType";
import { PASSIVE_JOB } from "../../constants/Filters";

interface Props {
  isOpen: boolean;
  setIsOpen: Function;
  modalData?: JobsDataType[] | null;
  setSelectedRowData?: Function;
  inventoryError?: Function;
}

const RenewListModal = ({
  isOpen,
  setIsOpen,
  modalData,
  setSelectedRowData = () => {},
  inventoryError = () => {},
}: Props) => {
  // const [jobIds, setJobIds] = useState<any>([]);
  const [renewJob, { isError, isSuccess, isLoading, data, error }] =
    useRenewJobMutation();
  // const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
    // setSelectedRowData();
  };

  // const handleRenew = async () => {
  //   const idsToExpire = modalData ? modalData.map((row) => row.jobId) : jobIds;

  //   const response = await renewJob(idsToExpire);
  //   console.log({ response, isSuccess, isError, error });

  //   if (isSuccess) {
  //     handleSnackbarOpen();
  //     handleClose();
  //   } else if (isError) {
  //     handleSnackbarOpenWithError();
  //     handleClose();
  //   }
  // };

  const handleRenew = async () => {
    const commonProperties = {
      autoRenew: false,
      expiryEnabled: false,
    };
  
    const renewJobIds = modalData
      ? modalData.filter((item)=>item?.jobFrom !== PASSIVE_JOB)
      .map((item) => {
            return { jobId: item.jobId, ...commonProperties };
        })
      : [];
  
    try {
      const result = await renewJob(renewJobIds).unwrap(); // Unwrapping here to get the actual data or throw an error
      // Assuming 'result' now contains the actual response data directly after unwrapping
      if (result && result.successCount !== undefined) {
        const successCount = parseInt(result.successCount);
        if (successCount === 0) {
          toast.error("Low inventory, Error renewing job(s)!", {
            autoClose: 5000,
            position: "bottom-left",
            toastId: "error-toast-custom",
          });
        } else if (successCount === modalData?.length) {
          toast.success("Job(s) Renewed Successfully", {
            autoClose: 5000,
            position: "bottom-left",
            toastId: "success-toast-custom",
          });
        } else {
          toast.info(`Only ${successCount}/${modalData?.length} Job(s) Renewed Successfully due to low Inventory`, {
            autoClose: 5000,
            position: "bottom-left",
            toastId: "info-toast-custom",
          });
        }
        
        if (setSelectedRowData) {
          setSelectedRowData([]);
        }
        handleClose();
      }
    } catch (error) {
      // Assuming error structure based on RTK Query Error
      toast.error("Error renewing job(s)!", {
        autoClose: 5000,
        position: "bottom-left",
        toastId: "error-toast-custom",
      });
      // if (error?.data?.errorCode === 'JP2040') {
      //   // Specific error handling if required
      // }
      handleClose();
    }
  };
  

  // const handleSnackbarOpen = () => {
  //   setSnackbarOpen(true);
  // };

  // const handleSnackbarOpenWithError = () => {
  //   setSnackbarOpen(true);
  // };

  // const handleSnackbarClose = () => {
  //   setSnackbarOpen(false);
  // };

  const formatDate = (dateString: string | undefined) => {
    if (!dateString) return "";

    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };

    const formattedDate = new Date(dateString).toLocaleDateString(
      undefined,
      options
    );
    return formattedDate;
  };

  const Header = (
    <MHeader>
      <div className="only-heading">
        <span className="mjp-modal-text-header">Renew Job?</span>
      </div>
    </MHeader>
  );

  const Footer = (
    <MFooter>
      <div className="expire-jobs-footer">
        <div style={{ width: "25%" }}>
          <button
            className="foundit-button primaryButton medium full-width"
            onClick={handleRenew}
          >
            Renew now
          </button>
        </div>
      </div>
    </MFooter>
  );

  return (
    <React.Fragment>
      <Modal
        modalId="mjp-modal-expire-jobs"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        header={Header}
        footer={Footer}
        closeIcon={<CloseIcon />}
        width="800px"
      >
        <div className="mjp-modal-body expire-jobs-body">
          <div className="mjp-modal-body-greybox">
            <h5>Do you want to renew the job(s)?</h5>
          </div>
          <div className="expire-jobs-list">
            {/* <ul className="jobs-list"> */}
            {(modalData || []).map((row, index) => {
               const {jobPostingType, jobType, jobFrom} = row || {};
               const jobTypeName = jobPostingType=='SJS' ? getMappedJobType('SOCIAL') : getMappedJobType(jobType?.name);
               if(jobFrom === PASSIVE_JOB) return null;

              return (
              <div 
              className={`renew-edit-list ${index < (modalData?.length  || 1) -1 ? 'single-row-border-bottom' : '' }`}
              >
                <div className="renew-list">
                  <p>
                    <span className="renew-title">{row?.title}</span>
                    {' '}
                   {jobTypeName && <span className="renew-job-type">({jobTypeName})</span>}
                  </p>
                  <p>
                    <span className="renew-modified-text">Last Modified: </span>
                    <span className="renew-modified-date">
                      {row?.updateDate && formatDate(row?.updateDate)}
                    </span>
                  </p>
                </div>

                <a
                  href={`${window.location.origin}/edge/jobposting/new-job-posting/edit/${row?.jobId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <EditIcon />
                </a>
              </div>
            )})}
            {/* </ul> */}
          </div>
        </div>
      </Modal>

      {/* <CustomSnackbar
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={
          isError ? "Error renewing job(s)!" : "Job(s) Renewed Successfully"
        }
        variant={isError ? "error" : "success"}
      /> */}
    </React.Fragment>
  );
};

export default RenewListModal;
